export const defaultStrings = {
    driver: "Driver",
    coDriver: "Co-driver",
    vehicle: "Vehicle",
    country: "Country",
    entered: "Entered",
    left: "Left",
    shown: "In this day",
    noCountry: "No country data",
    noVehicle: "No vehicle data",
    unknownVehicle: "Unknown vehicle",
    noDriverPeriod: "No driver data",
    countryCode: "Code",
    rest: "Rest",
    availability: "Available",
    work: "Work",
    driving: "Drive",
    noCard: "Not inserted",
    withDriverCard: "With driver card",
    withoutDriverCard: "Without driver card",
    withTachograph: "With tachograph",
    withoutTachograph: "Without tachograph",
    noData: "Missing data",
    outOfScope: "Out of scope",
    outOfScopeShort: "OOS",
    ferry: "Ferry crossing",
    dstForward: "Clocks forward",
    dstBack: "Clocks back",
    manual: "Manual",
    automatic: "Automatic",
    cardWithdrawal: "Card withdrawal",
    entryType: "Entry",
    driverName: "Driver",
    cardNumber: "Card",
    vin: "VIN",
    duration: "Duration",
    timeRange: "Time",
    total: "Total",
    totals: "Totals",
    totalsInView: "Totals in view",
    odometer: "Odo",
    km: "km",
    unknownDriver: "Unknown driver",
    unknownCard: "Unknown card",
    unknownCountry: "Unknown",
    highlight: "Highlight",
    marker: "Marker",
    zoomIn: "Zoom in",
    zoomOut: "Zoom out",
    resetZoom: "Reset zoom",
    reset: "Reset",
    selectRange: "Zoom to range",
    range: "Range",
    exportSvg: "SVG",
    exportPng: "PNG",
    noActivity: "No activity data",
    chartLabel: "Tachograph activity timeline",
    ferryAt: "Ferry crossing at",
    outOfScopeRange: "Out of scope",
    overview: "Overview",
    coDriverDisplay: "Co-driver row",
    coDriverAuto: "Auto",
    coDriverAlways: "Always",
    coDriverNever: "Never",
};
export function resolveStrings(overrides) {
    return overrides ? { ...defaultStrings, ...overrides } : { ...defaultStrings };
}
